import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { type DealDataRoom } from "@vega-api/generated/types/dealDataRoom";
import { m } from "@vega-core/paraglide/messages";

import { DataRoomAccessCard } from "../components/DataRoomAccessCard";
import { LpDataRoomView } from "../components/LpDataRoomView/LpDataRoomView";

type DataRoomTabProps = {
  dataRooms?: DealDataRoom[];
  dealOpportunityId: string;
  dealId?: string;
  vegaDataRoomId?: string;
};

export const DataRoomTab = ({
  dataRooms,
  dealOpportunityId,
  dealId,
  vegaDataRoomId,
}: DataRoomTabProps) => {
  const { featureFlag } = useFeatureFlag();
  const isDataRoomEnabled =
    featureFlag[FeatureFlag.COINVEST_DATA_ROOM_VD_22599];

  return (
    <div className="flex flex-col gap-6" data-testid="data-room-tab">
      <div className="body-base-regular text-text/secondary mb-4">
        {m.coInvestments_dataRoomTab_description()}
      </div>
      {isDataRoomEnabled && vegaDataRoomId && dealId ? (
        <LpDataRoomView
          dataRoomId={vegaDataRoomId}
          dealOpportunityId={dealOpportunityId}
        />
      ) : null}
      <div className="grid grid-cols-1 gap-4 lg:gap-6 border border-background/tertiary rounded-companyBorderRadius p-4 lg:py-6 lg:px-6 items-start lg:items-center">
        <h3 className="body-large-semibold lg:col-span-1 mb-3 lg:mb-0">
          {m.coInvestments_accessDataRoom_dataRoomTitle()}
        </h3>
        <div className="lg:col-span-2 space-y-4">
          {dataRooms
            ? dataRooms.map((dataRoom) => (
                <DataRoomAccessCard
                  dataRoom={dataRoom}
                  dealId={dealId}
                  dealOpportunityId={dealOpportunityId}
                  key={dataRoom.dataRoomProvider.name}
                />
              ))
            : null}
        </div>
      </div>
    </div>
  );
};
